import React, { useState } from "react";

const slides = [
  '/Images/office/IMG_3170-min.png',
  '/Images/office/IMG_3171-min.png',
  '/Images/office/IMG_3172-min.png',
  '/Images/office/IMG_3173-min.png',
  '/Images/office/IMG_3174-min.png',
  '/Images/office/IMG_3176-min.png',
  '/Images/office/IMG_3177-min.png',
  '/Images/office/IMG_3178-min.png',
  '/Images/office/IMG_3179-min.png',
  '/Images/office/IMG_3180-min.png',
  '/Images/office/IMG_3181-min.png',
  '/Images/office/IMG_3182-min.png',
  '/Images/office/IMG_3183-min.png',
  '/Images/office/IMG_3184-min.png',
  '/Images/office/IMG_3185-min.png',
  '/Images/office/IMG_3188-min.png',
  '/Images/office/IMG_3190-min.png',
  '/Images/office/IMG_3191-min.png',
  '/Images/office/IMG_3192-min.png',
];

const count = slides.length;

const ImageSlider = () => {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(c => (c === 0 ? count - 1 : c - 1));
  const next = () => setCurrent(c => (c === count - 1 ? 0 : c + 1));

  return (
    <div className="max-w-[1200px] mx-auto px-4 py-6">
      {/* Slide viewport */}
      <div
        className="relative w-full overflow-hidden rounded-2xl shadow-lg"
        style={{ height: '560px' }}
      >
        {slides.map((src, i) => {
          const isActive = i === current;
          const isAdjacent =
            i === (current - 1 + count) % count ||
            i === (current + 1) % count;

          return (
            <img
              key={src}
              src={src}
              alt={`Χώρος ιατρείου ${i + 1}`}
              loading={isActive || isAdjacent ? 'eager' : 'lazy'}
              className="absolute inset-0 w-full h-full object-cover"
              style={{
                opacity: isActive ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out',
                zIndex: isActive ? 1 : 0,
              }}
            />
          );
        })}

        {/* Left arrow */}
        <button
          onClick={prev}
          aria-label="Προηγούμενη φωτογραφία"
          className="absolute left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full shadow-md transition-all duration-200 cursor-pointer"
        >
          <i className="fa-solid fa-chevron-left text-gray-700 text-sm"></i>
        </button>

        {/* Right arrow */}
        <button
          onClick={next}
          aria-label="Επόμενη φωτογραφία"
          className="absolute right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-white rounded-full shadow-md transition-all duration-200 cursor-pointer"
        >
          <i className="fa-solid fa-chevron-right text-gray-700 text-sm"></i>
        </button>
      </div>

      {/* Dot navigation */}
      <div className="flex justify-center items-center gap-2 mt-4">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Φωτογραφία ${i + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === current
                ? 'bg-sky-600 w-6'
                : 'bg-gray-300 hover:bg-sky-300 w-2'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
